export default __webpack_public_path__ + "static/media/alcx_logo_only.329031f6.svg";